import { useState, ReactNode } from 'react';
import { Link, Typography } from '@optimus-web/core';
import { PaymentMethod } from '@mews-commander/data-access';
import { WithAccountId } from '@mews-commander/types';
import { ModalSidePanel } from '@mews-commander/ui';
import { PaymentMethodDetailsSidebar } from './PaymentMethodDetailsSidebar';

interface Props extends WithAccountId {
    paymentCardId: string;
    isOpen: boolean;
    closeDialog: () => void;
    paymentMethodType: PaymentMethod;
    title: ReactNode;
}

export const PaymentMethodDetails = ({
    paymentCardId,
    accountId,
    isOpen,
    closeDialog,
    paymentMethodType,
    title,
}: Props) => (
    <ModalSidePanel
        opened={isOpen}
        title={
            <Typography textStyle="titleMediumStrong" as="div">
                {title}
            </Typography>
        }
        onClose={closeDialog}
        width="small"
        headerActions={null}
        content={
            <PaymentMethodDetailsSidebar
                paymentCardId={paymentCardId}
                accountId={accountId}
                paymentMethodType={paymentMethodType}
            />
        }
    />
);

export interface PaymentCardDetailsLegacyProps {
    paymentCardId: string;
    paymentCardNumber: string;
    customerId: string;
}

// todo - remove when switching to Payment Methods table
export const PaymentCardDetailsLegacy = ({
    paymentCardNumber,
    paymentCardId,
    customerId,
}: PaymentCardDetailsLegacyProps) => {
    const [opened, setOpened] = useState(false);

    return (
        <>
            <Link inherit onClick={() => setOpened(true)}>
                {paymentCardNumber}
            </Link>
            <PaymentMethodDetails
                paymentCardId={paymentCardId}
                accountId={customerId}
                isOpen={opened}
                closeDialog={() => setOpened(false)}
                paymentMethodType={PaymentMethod.PaymentCard}
                title={paymentCardNumber}
            />
        </>
    );
};
